import React from 'react'
import d9 from './MenuIcon.module.css'
function MenuIcon(props) {
    return (
        <div className={props.state?d9.opened: d9.closed} onClick={props.onClick}>
          
    <label className={d9.MenuIcon} >

      <span/>
      <span/>
      <span/>

    </label>
 
        </div>
    )
}

export default MenuIcon
